export const spdPlusArticle = {
    id: 'spd-plus-module',
    title: 'Продвинутая геометрия (SPD+)',
    category: 'Модули',
    requiredModule: 'spd-plus',
    summary: 'Топологические операции: вычитание контуров, слияние полигонов и буферные зоны.',
    markdown: `
## Продвинутая геометрия (SPD Plus)

Расширенный набор топологических функций для работы со сложной пространственной конфигурацией.

### Топологические инструменты:
- **Вычитание (Difference):** формирование внутренних анклавов и вырезка пятен застройки из земельных массивов.
- **Слияние (Union):** объединение смежных контуров в единый объект.
- **Буферные зоны:** автоматический расчет защитных полос и отступов от границ.
`
};
